'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('@appbaseio/reactivecore/lib/utils/constants');

var _PreferencesConsumer = require('../basic/PreferencesConsumer');

var _PreferencesConsumer2 = _interopRequireDefault(_PreferencesConsumer);

var _SingleList = require('../list/SingleList');

var _SingleList2 = _interopRequireDefault(_SingleList);

var _ReactiveList = require('../result/ReactiveList');

var _ReactiveList2 = _interopRequireDefault(_ReactiveList);

var _SearchBox = require('../search/SearchBox');

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _MultiList = require('../list/MultiList');

var _MultiList2 = _interopRequireDefault(_MultiList);

var _SingleDataList = require('../list/SingleDataList');

var _SingleDataList2 = _interopRequireDefault(_SingleDataList);

var _TabDataList = require('../list/TabDataList');

var _TabDataList2 = _interopRequireDefault(_TabDataList);

var _MultiDataList = require('../list/MultiDataList');

var _MultiDataList2 = _interopRequireDefault(_MultiDataList);

var _SingleDropdownList = require('../list/SingleDropdownList');

var _SingleDropdownList2 = _interopRequireDefault(_SingleDropdownList);

var _MultiDropdownList = require('../list/MultiDropdownList');

var _MultiDropdownList2 = _interopRequireDefault(_MultiDropdownList);

var _SingleDropdownRange = require('../range/SingleDropdownRange');

var _SingleDropdownRange2 = _interopRequireDefault(_SingleDropdownRange);

var _MultiDropdownRange = require('../range/MultiDropdownRange');

var _MultiDropdownRange2 = _interopRequireDefault(_MultiDropdownRange);

var _NumberBox = require('./NumberBox');

var _NumberBox2 = _interopRequireDefault(_NumberBox);

var _TagCloud = require('../list/TagCloud');

var _TagCloud2 = _interopRequireDefault(_TagCloud);

var _ToggleButton = require('../list/ToggleButton');

var _ToggleButton2 = _interopRequireDefault(_ToggleButton);

var _DatePicker = require('../date/DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _DateRange = require('../date/DateRange');

var _DateRange2 = _interopRequireDefault(_DateRange);

var _SingleRange = require('../range/SingleRange');

var _SingleRange2 = _interopRequireDefault(_SingleRange);

var _MultiRange = require('../range/MultiRange');

var _MultiRange2 = _interopRequireDefault(_MultiRange);

var _RangeSlider = require('../range/RangeSlider');

var _RangeSlider2 = _interopRequireDefault(_RangeSlider);

var _DynamicRangeSlider = require('../range/DynamicRangeSlider');

var _DynamicRangeSlider2 = _interopRequireDefault(_DynamicRangeSlider);

var _RatingsFilter = require('../range/RatingsFilter');

var _RatingsFilter2 = _interopRequireDefault(_RatingsFilter);

var _RangeInput = require('../range/RangeInput');

var _RangeInput2 = _interopRequireDefault(_RangeInput);

var _ReactiveChart = require('../chart/ReactiveChart');

var _ReactiveChart2 = _interopRequireDefault(_ReactiveChart);

var _TreeList = require('../list/TreeList');

var _TreeList2 = _interopRequireDefault(_TreeList);

var _ReactiveComponent = require('./ReactiveComponent');

var _ReactiveComponent2 = _interopRequireDefault(_ReactiveComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForwardRefComponent = _react2.default.forwardRef(function (props, ref) {
	return _react2.default.createElement(
		_PreferencesConsumer2.default,
		{ userProps: props },
		function (preferenceProps) {
			switch (preferenceProps.componentType) {
				case _constants.componentTypes.treeList:
					return _react2.default.createElement(_TreeList2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.reactiveList:
					return _react2.default.createElement(_ReactiveList2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.searchBox:
					return _react2.default.createElement(_SearchBox2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				// list components
				case _constants.componentTypes.singleList:
					return _react2.default.createElement(_SingleList2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.multiList:
					return _react2.default.createElement(_MultiList2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.singleDataList:
					return _react2.default.createElement(_SingleDataList2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.tabDataList:
					return _react2.default.createElement(_TabDataList2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.multiDataList:
					return _react2.default.createElement(_MultiDataList2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.singleDropdownList:
					return _react2.default.createElement(_SingleDropdownList2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.multiDropdownList:
					return _react2.default.createElement(_MultiDropdownList2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.singleDropdownRange:
					return _react2.default.createElement(_SingleDropdownRange2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.multiDropdownRange:
					return _react2.default.createElement(_MultiDropdownRange2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				// basic components
				case _constants.componentTypes.numberBox:
					return _react2.default.createElement(_NumberBox2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.tagCloud:
					return _react2.default.createElement(_TagCloud2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.toggleButton:
					return _react2.default.createElement(_ToggleButton2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				// range components
				case _constants.componentTypes.datePicker:
					return _react2.default.createElement(_DatePicker2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.dateRange:
					return _react2.default.createElement(_DateRange2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.dynamicRangeSlider:
					return _react2.default.createElement(_DynamicRangeSlider2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.singleRange:
					return _react2.default.createElement(_SingleRange2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.multiRange:
					return _react2.default.createElement(_MultiRange2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.rangeSlider:
					return _react2.default.createElement(_RangeSlider2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.ratingsFilter:
					return _react2.default.createElement(_RatingsFilter2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.rangeInput:
					return _react2.default.createElement(_RangeInput2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.reactiveChart:
					return _react2.default.createElement(_ReactiveChart2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
				case _constants.componentTypes.reactiveComponent:
				default:
					return _react2.default.createElement(_ReactiveComponent2.default, _extends({}, preferenceProps, { myForwardedRef: ref }));
			}
		}
	);
});

ForwardRefComponent.displayName = 'ReactiveComponentPrivate';
exports.default = ForwardRefComponent;